import React from "react";
import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const SeminarHeadlineAndButton = ({ blok }) => (
  <div className="flex justify-center" {...storyblokEditable(blok)}>
    <div className="seminar-headline-and-button-wrap-outer flex flex-col justify-center">
      <div className="seminar-headline-and-button-wrap-inner">
        <div className="seminar-headline-and-button-wrap-content">
          <div className="flex flex-col">
            <h2 className="text-2xl seminar-headline-and-button-headline">
              {blok.subheadline}
            </h2>
          </div>
          <div className="headline-and-button-wrap-button">
            <Link target="_blank" href={blok.buttonLink} >
                <button className="btn">{blok.button}</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SeminarHeadlineAndButton;
